const mapLayerStyles = [
    {
        'id': 'landkreise-default',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': [
                'case',
                ['==', ['get', 'projectsCount'], 0 ], ['rgba', 0, 0, 0, 0.15],
                ['>', ['get', 'projectsCount'], 30 ], ['rgba', 0, 0, 0, 1],
                ['>', ['get', 'projectsCount'], 20 ], ['rgba', 0, 0, 0, 0.75],
                ['>', ['get', 'projectsCount'], 10 ], ['rgba', 0, 0, 0, 0.55],
                ['<=', ['get', 'projectsCount'], 10 ], ['rgba', 0, 0, 0, 0.35],
                'black'
            ]
        }
    },
    {
        'id': 'landkreise-infrastructure',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': [
                'case',
                ['==', ['get', 'projectsInfrastructure'], 0 ], '#ed8cd3',
                ['>', ['get', 'projectsInfrastructure'], 30 ], '#36152D',
                ['>', ['get', 'projectsInfrastructure'], 20 ], '#5C254D',
                ['>', ['get', 'projectsInfrastructure'], 10 ], '#82346D',
                ['<=', ['get', 'projectsInfrastructure'], 10 ], '#C24EA3',
                'black'
            ]
        }
    },
    {
        'id': 'landkreise-mobility',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': [
                'case',
                ['==', ['get', 'projectsMobility'], 0 ], '#ddff8e',
                ['>', ['get', 'projectsMobility'], 30 ], '#354510',
                ['>', ['get', 'projectsMobility'], 20 ], '#526B19',
                ['>', ['get', 'projectsMobility'], 10 ], '#709121',
                ['<=', ['get', 'projectsMobility'], 10 ], '#A1D130',
                'black'
            ]
        }
    },
    {
        'id': 'landkreise-economy',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': [
                'case',
                ['==', ['get', 'projectsEconomy'], 0 ], '#b2e0fb',
                ['>', ['get', 'projectsEconomy'], 30 ], '#2C3345',
                ['>', ['get', 'projectsEconomy'], 20 ], '#454F6B',
                ['>', ['get', 'projectsEconomy'], 10 ], '#5B698F',
                ['<=', ['get', 'projectsEconomy'], 10 ], '#869AD1',
                'black'
            ]
        }
    },
    {
        'id': 'landkreise-housing',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': [
                'case',
                ['==', ['get', 'projectsHousing'], 0 ], '#ffe88e',
                ['>', ['get', 'projectsHousing'], 30 ], '#472F09',
                ['>', ['get', 'projectsHousing'], 20 ], '#6B470E',
                ['>', ['get', 'projectsHousing'], 10 ], '#8F5F13',
                ['<=', ['get', 'projectsHousing'], 10 ], '#D18B1B',
                'black'
            ]
        }
    },
    {
        'id': 'landkreise-line',
        'type': 'line',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                'darkgray',
                'lightgray'
            ],
            'line-width': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                2,
                1
            ],
        }
    },
    {
        'id': 'landkreise-mouse',
        'type': 'fill',
        'source': 'landkreise',
        'layout': {},
        'paint': {
            'fill-color': 'transparent',
            'fill-opacity': 0,
        }
    }
]

export default mapLayerStyles